import { render } from "./Notification.vue?vue&type=template&id=12dd2063"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\bert\\Documents\\Projects\\v-tax-chauffeurs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__